import { create } from "zustand";

const useBookableDurationStore = create((set) => ({
    bookableDurations: [],
    setBookableDurations: (value) => set({ bookableDurations: value }),
    updateBookableDuration: (updatedBookableDuration) => set((state) => ({
      bookableDurations: state.bookableDurations.map((bookableDuration) => bookableDuration.id === updatedBookableDuration.id ? { ...bookableDuration, ...updatedBookableDuration } : bookableDuration)
    })),
    addBookableDuration: (bookableDuration) => set((state) => ({
      bookableDurations: [...state.bookableDurations, bookableDuration]
    })),
    removeBookableDuration: (removedBookableDuration) => set((state) => ({
      bookableDurations: state.bookableDurations.filter((bookableDuration) => removedBookableDuration.id !== bookableDuration.id)
    })),

    itemBookableDurations: [],
    setItemBookableDurations: (value) => set({ itemBookableDurations: value }),
    updateItemBookableDuration: (updatedItemBookableDuration) => set((state) => ({
      itemBookableDurations: state.itemBookableDurations.map((itemBookableDuration) => itemBookableDuration.id === updatedItemBookableDuration.id ? { ...itemBookableDuration, ...updatedItemBookableDuration } : itemBookableDuration)
    })),
  })
);

export default useBookableDurationStore;